import { render, staticRenderFns } from "./EsqueciMinhaSenha.vue?vue&type=template&id=c2005212&scoped=true"
import script from "./EsqueciMinhaSenha.vue?vue&type=script&lang=js"
export * from "./EsqueciMinhaSenha.vue?vue&type=script&lang=js"
import style0 from "./EsqueciMinhaSenha.vue?vue&type=style&index=0&id=c2005212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2005212",
  null
  
)

export default component.exports